<template>
  <vxe-modal
    ref="xModal"
    v-model="visible"
    :width="modalWidth"
    :height="modalHeight"
    :mask="showMask"
    :lockView="false"
    :lock-scroll="false"
  >
    <template #header>
      <span>详细设计查询</span>
      <i title="最小化" v-if="!isMini" class="vxe-modal--min-btn trigger--btn vxe-icon--minus" @click="modalToMini"></i>
      <i title="还原" v-else class="vxe-modal--min-btn trigger--btn vxe-icon--zoomout" @click="modalToOriginal"></i>
      <i title="关闭" class="vxe-modal--close-btn trigger--btn vxe-icon--close" @click="closeModal"></i>
    </template>

    <template #default>
      <!-- 查找面板 -->
      <div class="search-dv">
        <div class="search-container">
          <!-- 输入框 -->
          <div class="input-dv">
            <!-- 动态选渲染查询条件 -->
            <el-form size="mini" ref="SearchFormRef" @keyup.enter.native="search" :model="searchForm" :inline="true">
              <!-- <el-form-item label="时间节点" :label-width="'120px'" prop="dateStr">
                <el-select v-model="searchForm.dateStr" :placeholder="messageConfig.selectPlaceholder">
                  <el-option v-for="i of ComBoxItems.dateStr" :key="i + ''" :label="i" :value="i"></el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="问题号" :label-width="'120px'" prop="ykCaseID" v-if="searchForm.ykCaseID">
                <el-select
                  clearable
                  v-model="searchForm.ykCaseID"
                  :placeholder="messageConfig.relationPlaceholder"
                  disabled
                >
                  <el-option
                    v-for="(item, index) of numOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="页面" :label-width="'120px'" prop="vuePath">
                <el-input
                  v-model="searchForm.vuePath"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                ></el-input>
              </el-form-item>

              <el-form-item label="详设类型" :label-width="'120px'" prop="designType">
                <el-select clearable v-model="searchForm.designType" :placeholder="messageConfig.selectPlaceholder">
                  <el-option label="前端" value="前端"></el-option>
                  <el-option label="后端" value="后端"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="功能点(模糊)" :label-width="'120px'" prop="functionPoint">
                <el-input
                  v-model="searchForm.functionPoint"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                ></el-input>
              </el-form-item>

              <el-form-item label="功能点(精确)" :label-width="'120px'" prop="functionPointExact">
                <el-input
                  v-model="searchForm.functionPointExact"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                ></el-input>
              </el-form-item>

              <el-form-item label="设计人" :label-width="'120px'" prop="designers">
                <el-input
                  v-model="searchForm.designers"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                ></el-input>
              </el-form-item>

              <!-- <el-form-item label="起始时间" :label-width="'120px'" prop="startTime">
                <el-date-picker
                  type="datetime"
                  :placeholder="placeholderConfig.input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="searchForm.startTime"
                ></el-date-picker>
              </el-form-item> -->

              <!-- <el-form-item label="截止时间" :label-width="'120px'" prop="endTime">
                <el-date-picker
                  type="datetime"
                  :placeholder="placeholderConfig.input"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="searchForm.endTime"
                ></el-date-picker>
              </el-form-item> -->
            </el-form>
          </div>
          <!-- 按钮 -->
          <div class="save-button-dv">
            <!-- type="primary" -->
            <el-button icon="el-icon-search" ref="btnSearch" size="mini" @click="search">查询</el-button>
            <el-button type="info" icon="el-icon-refresh" size="mini" @click="resetSearchForm">重置 </el-button>
          </div>
        </div>
      </div>
      <YKDivider>数据</YKDivider>
      <div class="diffListContainer" :style="{ height: containerHeight }">
        <div class="diffListItem" v-for="(item, index) of diffList" :key="index">
          <div class="diffListItemTitile">
            <span style="font-weight: bold;">
              [{{ item.designType }}] {{ item.designers }} {{ ykDateFormat('yyyy-MM-dd HH:mm', item.designTime) }}
            </span>
            ({{ item.functionPoint }})
          </div>
          <div class="diffListItemContent">
            <div
              class="ql-container ql-snow contentOrigin"
              :style="{ width: !item.putAway ? 'calc(50% - 10px)' : '100%' }"
            >
              <YKDivider>详设</YKDivider>
              <div class="ql-editor" style="padding-left: 8px; padding-right: 8px;" v-html="item.content"></div>
            </div>
            <div
              class="contentDiff"
              :style="{
                width: !item.putAway ? 'calc(50% - 10px)' : '0px',
                padding: !item.putAway ? '5px' : '0px'
              }"
            >
              <div
                class="zoomBtn"
                :style="{ left: !item.putAway ? '-17px' : '-12px' }"
                @click="handleZoomOldItem(item)"
              >
                <i v-if="item.putAway" class="vxe-icon--arrow-left"></i>
                <i v-else class="vxe-icon--arrow-right"></i>
              </div>
              <div class="diffConponent" v-show="!item.putAway && diffRenderTimers.includes(item.id)">
                <YKDivider>差异</YKDivider>
                <DiffComponent :newContent="item.content" :oldContent="lastContent[item.id] || ''" />
              </div>
            </div>
            <!-- 旧版 -->
            <!-- <div
              class="contentDiff"
              :style="{ width: !item.putAway ? 'calc(50% - 10px)' : '0px', padding: !item.putAway ? '5px' : '0px' }"
              v-if="item.oldContent"
            >
              <div
                class="zoomBtn"
                :style="{ left: !item.putAway ? '-17px' : '-12px' }"
                @click="handleZoomOldItem(item)"
              >
                <i v-if="item.putAway" class="vxe-icon--arrow-left"></i>
                <i v-else class="vxe-icon--arrow-right"></i>
              </div>
              <YKDivider v-if="!item.putAway">差异</YKDivider>
            </div> -->
          </div>
        </div>

        <div class="null-data" v-if="diffList.length === 0">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[5, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
  </vxe-modal>
</template>
<script>
import DiffComponent from './DiffComponent.vue'

export default {
  components: {
    DiffComponent
  },
  data() {
    return {
      visible: false,
      // 最小宽高
      minWidth: '187px',
      minHeight: '38px',
      // 默认宽高
      modalWidth: '100%',
      modalHeight: '100%',
      // 是否展示遮罩
      showMask: false,
      // 是否缩放
      isMini: false,
      // 查询条件
      searchForm: {
        vuePath: '',
        designType: '',
        functionPoint: '',
        functionPointExact: '',
        designers: '',
        ykCaseID: ''
      },
      // 明细数据
      diffList: [
        // {
        //   putAway: false,
        //   id: 5,
        //   content:
        //     '<p>我准备写一篇新的内容, 不需要原先的测试数据</p><p><img src="http://localhost:8080/testUploadApi/downloadnew/------WebKitFormBoundaryQQ32RszqmbgVCvhc--/1727429666181_dbde98ede4e1b017d66dcc773e0b58a8.png"></p>',
        //   oldContent:
        //     '<p>我准备写一篇新的内容, 不需要原先的测试数据</p><p><img src="http://localhost:8080/testUploadApi/downloadnew/------WebKitFormBoundaryQQ32RszqmbgVCvhc--/1727429666181_dbde98ede4e1b017d66dcc773e0b58a8.png"></p>',
        //   ykCaseID: 5183,
        //   productionType: '铁塔',
        //   vuePath: '原材料库存',
        //   designType: '前端',
        //   functionPoint: '这是一个新的功能点',
        //   designers: '刘福',
        //   designContent: '/nginx/fileload2\\xzFile\\原材料库存\\1727429668371.txt',
        //   designTime: '2024-09-27 17:34:28'
        // },
        // {
        //   putAway: false,
        //   id: 5,
        //   content:
        //     '<p>我准备写一篇新的内容, 不需要原先的测试数据</p><p><img src="http://localhost:8080/testUploadApi/downloadnew/------WebKitFormBoundaryQQ32RszqmbgVCvhc--/1727429666181_dbde98ede4e1b017d66dcc773e0b58a8.png"></p>',
        //   oldContent: '',
        //   ykCaseID: 5183,
        //   productionType: '铁塔',
        //   vuePath: '原材料库存',
        //   designType: '前端',
        //   functionPoint: '这是一个新的功能点',
        //   designers: '刘福',
        //   designContent: '/nginx/fileload2\\xzFile\\原材料库存\\1727429668371.txt',
        //   designTime: '2024-09-27 17:34:28'
        // }
      ],
      // 问题号下拉框
      numOptions: [],
      // 当前页码
      pageIndex: 1,
      // 每页条数
      pageSize: 20,
      // 数据总量
      total: 0,
      // 差异渲染定时器
      diffRenderTimers: [],
      // 上一次内容
      lastContent: {}
    }
  },
  methods: {
    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.sureSearch()
    },
    handleCurrentChange(index) {
      this.pageIndex = index
      this.sureSearch()
    },
    async handleZoomOldItem(item) {
      if (item.putAway) {
        if (!this.lastContent[item.id]) {
          // todo 获取旧版内容
          const { data: res } = await this.$http.post(
            '/Common/YKDetailDesign/last',
            {
              ykDetailDesignID: item.id
            },
            {
              headers: {
                loading: false
              }
            }
          )
          if (!res.isSuccess) {
            this.$message.error(res.errorMessage)
            return false
          }
          // item.oldContent = res.data.lastDesign.content
          this.lastContent[item.id] = res.data.lastDesign.content
        }
        setTimeout(() => {
          this.diffRenderTimers.push(item.id)
        }, 250)
      } else {
        this.diffRenderTimers = this.diffRenderTimers.filter(i => i !== item.id)
      }

      item.putAway = !item.putAway
    },
    // 重置查询条件
    resetSearchForm() {
      this.searchForm = {
        vuePath: '',
        designType: '',
        functionPoint: '',
        functionPointExact: '',
        designers: '',
        ykCaseID: ''
      }
    },
    // 查找
    search() {
      this.pageIndex = 1
      this.sureSearch()
    },
    // 查找后事件
    async sureSearch() {
      // 获取明细
      let req = {
        productionType: this.$store.state.productType,
        vuePath: this.searchForm.vuePath,
        designType: this.searchForm.designType,
        functionPoint: this.searchForm.functionPoint,
        designers: this.searchForm.designers,
        functionPointExact: this.searchForm.functionPointExact,
        ykCaseID: this.searchForm.ykCaseID,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }

      req = this.removeObjectNull(req)

      const { data: res } = await this.$http.post('/Common/YKDetailDesign/list', req)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.diffRenderTimers = []

      let diffList = res.data.rows
      diffList = diffList.map(item => ({ ...item, putAway: true }))

      this.total = res.data.totals
      this.diffList = diffList
    },
    // 最小化窗体
    modalToMini() {
      this.isMini = true

      this.modalWidth = this.minWidth
      this.modalHeight = this.minHeight
      // this.showMask = false
      this.$refs.xModal.setPosition(this.$store.state.clientHeight - 38, 0)
    },
    // 还原窗体
    modalToOriginal() {
      this.isMini = false

      this.modalWidth = '100%'
      this.modalHeight = '100%'
      this.$refs.xModal.setPosition(0, 0)
    },
    openModal(row = {}, numOptions = []) {
      this.resetSearchForm()

      this.lastContent = {}
      this.diffRenderTimers = []

      this.numOptions = numOptions

      this.searchForm = { ...this.searchForm, ...row }

      // 调用搜索
      this.sureSearch()

      this.visible = true
    },
    closeModal() {
      this.visible = false
    }
  },
  computed: {
    containerHeight() {
      // 43 为表头高度
      // 23 为padding间隔
      // 33 为分隔线高度
      // 90 为查询面板高度
      // 42 分页
      // 5 为预留间隔
      return this.$store.state.clientHeight - 43 - 23 - 33 - 90 - 42 - 5 + 'px'
    }
  }
}
</script>
<style lang="less" scoped>
.vxe-modal--min-btn {
  position: absolute;
  right: 40px;
  top: 0.85em;
  z-index: 3;
  cursor: pointer;
}

.diffListContainer {
  width: 100%;
  box-shadow: #bebebe 2px 2px 10px;

  border-radius: 10px;

  position: relative;

  box-sizing: border-box;
  padding: 10px;

  .diffListItem {
    background-color: #dfeefd;
    box-sizing: border-box;
    padding: 10px;

    width: 100%;

    border: 1px solid #81bbf8;
    border-radius: 5px;

    .diffListItemTitile {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .diffListItemContent {
      display: flex;
      justify-content: space-between;
      .contentOrigin {
        background-color: #fafafa;
        border-radius: 5px;
        border: 0px;

        box-sizing: border-box;
        padding: 5px;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 7px;
          // height: auto;
        }
        /*滚动条里面小方块*/
        &::-webkit-scrollbar-thumb {
          border-radius: 20px;
          background-color: skyblue;
          background-image: -webkit-linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent
          );
        }
        /*滚动条里面轨道*/
        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
          background: #ededed;
          border-radius: 20px;
        }
      }
      .contentDiff {
        // flex: 1;
        background-color: #fafafa;
        border-radius: 5px;

        box-sizing: border-box;

        position: relative;

        .zoomBtn {
          position: absolute;
          left: -17px;
          top: 50%;
          transform: translate(0, -50%);
          border-radius: 3px;
          width: 15px;
          height: 55px;
          // line-height: 55px;
          // text-align: center;
          box-shadow: 0px 0px 5px #999;

          color: #fff;

          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #6eb6ff;
          transition: all 0.3s;
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }
        transition: width 0.3s;

        .diffConponent {
          width: 100%;
          overflow: auto;

          &::-webkit-scrollbar {
            width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 7px;
            // height: auto;
          }
          /*滚动条里面小方块*/
          &::-webkit-scrollbar-thumb {
            border-radius: 20px;
            background-color: skyblue;
            background-image: -webkit-linear-gradient(
              45deg,
              rgba(255, 255, 255, 0.2) 25%,
              transparent 25%,
              transparent 50%,
              rgba(255, 255, 255, 0.2) 50%,
              rgba(255, 255, 255, 0.2) 75%,
              transparent 75%,
              transparent
            );
          }
          /*滚动条里面轨道*/
          &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
            background: #ededed;
            border-radius: 20px;
          }
        }
      }

      .contentOrigin + .contentDiff {
        margin-left: 20px;
      }
    }
  }

  .diffListItem + .diffListItem {
    margin-top: 10px;
  }

  overflow: auto;

  &::-webkit-scrollbar {
    width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
    // height: auto;
  }
  /*滚动条里面小方块*/
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
  /*滚动条里面轨道*/
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: #ededed;
    border-radius: 20px;
  }
}

.null-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// ---------------- 查找条件部分 ----------------
@plan-width: 200px;
.search-dv {
  background-color: aquamarine;
  height: 60px;
  margin: @main-margin 0;
  border-radius: 10px;
  box-shadow: #bebebe 2px 2px 10px;

  overflow: hidden;
}

.search-container {
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #ffffff;

  .input-dv {
    // box-sizing: border-box;
    // padding: 15px 0;
    width: calc(100% - @plan-width);
    height: 100%;
    overflow: auto;
    // background-color: #ebebeb;
    background-color: #f2f3f5;
    .fl;
    justify-content: flex-start;
  }

  .save-button-dv {
    width: @plan-width;
    height: 100%;
    background-color: #f2f3f5;
    .fl;
  }
}

/deep/ .el-date-editor {
  .el-input__inner {
    padding-right: 15px !important;
  }
}

/deep/ .el-input__inner {
  height: 24px !important;
}
// ---------------------------------------------
</style>
